var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expertDetails"},[(_vm.expertDetailsObj.contentEditor)?_c('div',{staticClass:"expertDetails-box"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.expertDetailsObj.contentEditor.content)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }